import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import ToastViewport from "./components/ToastViewport";
import DialogViewport from "./components/DialogViewport";
import AuthProvider from "./context/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
    <ToastViewport />
    <DialogViewport />
  </AuthProvider>
);
